import {instance} from '../../repositories/DataSource.js';

export default function (token, type) {
    const token_id = localStorage.getItem('token_id');

    if (!token_id) {
        instance.post('fcm-tokens', {
            token,
            type
        }).then(({data: {data: patientFcmToken}}) => {
            localStorage.setItem('token_id', patientFcmToken.id);
        })
    }
}
